<template>
  <div class="d-flex justify-content-center" style="margin-top: 20px; padding-bottom: 20%;">
    <b-row>
      <b-col md="12">
        <FormulateForm
          @submit="submitHandler"
          class="login-form"
          v-model="formValues"
          validation-behavior="submit"
          invalid-message="Email inválido"
          :form-errors="formErrors"
          :wrapper-class="['d-flex', 'justify-content-center']"
        >
          <h2>Entrar</h2>
          <FormulateInput
            name="email"
            type="text"
            label="Email do usuário"
            placeholder="Endereço de email"
            validation="required|email"
            :disabled="isLoggingIn"
          />
          <FormulateInput
            name="password"
            type="password"
            label="Senha"
            placeholder="Senha"
            validation="required"
            :disabled="isLoggingIn"
          />
          <FormulateErrors />

          <FormulateInput
            type="submit"
            label="Entrar"
            :disabled="isLoggingIn"
          >
            Entrar <span v-if="isLoggingIn" class="loader"><img width="20px" :src="loaderGif" alt=""/></span>
          </FormulateInput>
          
          <b-row style="margin-bottom: 20px; margin-top: 40px">
            <router-link to="/password-forgotten">Esqueci minha senha</router-link>
          </b-row>

        </FormulateForm>
      </b-col>
    </b-row>
  </div>

</template>

<script>
import loaderGif from '../assets/images/loader.gif'

export default {
  name: 'Login',
  components: {

  },
  data() {
    return {
      formValues: {
        email: '',
        password: '',
      },
      formErrors: [],
      isLoggingIn: false,
      loaderGif,
    }
  },
  methods: {
    async submitHandler(credentials) {

      this.isLoggingIn = true;

      await this.$store.dispatch('loginUser', credentials);

      if (this.$store.state.isUserLoggedIn) {
        this.formErrors = [];
      }
      else {
        this.formErrors = ['Erro ao fazer login: usuário ou senha inválidos'];
      }

      this.isLoggingIn = false;
    }
  }
}
</script>

<style scoped>

.center {
  justify-content: center;
}

.loader {
  margin-left: 10px;
}

</style>
